import { Settings, SettingsApi } from '~/types';

export const settingsParser = (settings: SettingsApi): Settings => ({
  automaticAllocation: settings.automatic_allocation,
  defaultStrategy: Number(settings.default_strategy),
});
